module.exports = __webpack_public_path__ + "img/9788952795496.69614d03.jpg";